<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-01 18:20:18
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-10-27 10:37:24
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\setTemplate\components\sendRecord\index.vue
-->
<!-- 模板消息 -->
<template>
    <el-container class='setTemplate'>
        <div class="headerCom">
            <div class="text"><span>运营管理 / 模板消息 / </span><span>发送记录</span></div>
            <!-- 搜索 -->
            <div class="search">
                <div class="left">
                    <el-select v-model="selectChange" size='mini' style="width: 166px;margin-right:20px"
                        @change="selectChangeFunction">
                        <el-option label="模板消息名称" :value="1"></el-option>
                        <el-option label="公众号" :value="2"></el-option>
                        <el-option label="推送方式" :value="3"></el-option>
                        <el-option label="发送时间" :value="4"></el-option>
                    </el-select>
                    <el-input v-if="selectChange == 1" placeholder="请输入内容" style="width: 166px;margin-right:20px"
                        size='mini' v-model="templateName">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-select v-if="selectChange == 2" v-model="searchForm.appId" size='mini'
                        style="width: 166px;margin-right:20px">
                        <el-option v-for="(item, index) in wechatList" :key="index" :label="item.name"
                            :value="item.appId"></el-option>
                    </el-select>
                    <el-select v-if="selectChange == 3" v-model="searchForm.sendType" size='mini'
                        style="width: 166px;margin-right:20px">
                        <el-option label="标签" value="标签"></el-option>
                        <el-option label="用户" value="用户"></el-option>
                        <el-option label="系统" value="系统"></el-option>
                    </el-select>
                    <el-date-picker v-if="selectChange == 4" style="margin-right: 20px;" size="mini"
                        value-format="yyyy-MM-dd" v-model="times" :default-time="['00:00:00']" clearable align="center"
                        popper-class="popper-class" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" @change="timeChange">
                    </el-date-picker>
                    <el-button type="primary" size='mini' @click="getdata()">搜索</el-button>
                    <el-button size='mini' @click="resectData()">重置</el-button>
                </div>
            </div>
        </div>
        <el-main class="container-box">
            <div class="i-container" v-loading="loading">
                <el-table id="tableInfo" :data="tableData" style="width: 100%">
                    <el-table-column prop="id" show-overflow-tooltip label="推送ID" align="center">
                    </el-table-column>
                    <el-table-column prop="templateTitle" label="模板名" align="center"></el-table-column>
                    <el-table-column prop="wechatName" label="对应公众号" align="center"></el-table-column>
                    <el-table-column prop="sendType" label="推送方式" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="发送时间" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" slot="reference"
                                @click="sendDetail(scope.row, scope.$index)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="dialog-pagination">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="searchForm.current" :page-size="searchForm.size"
                        layout="total, sizes, prev, pager, next, jumper" :total="tableTotal">
                    </el-pagination>
                </div>
            </div>
        </el-main>
        <!-- 详情弹窗 -->
        <el-dialog @close="userClose" :visible.sync="setDialog" v-if="setDialog"
            :width="viewRight == false ? '30%' : '70%'" title="查看详情">
            <div class="d-height">
                <div class="d-content">
                    <div class="left" style="width: 100%;">
                        <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                            <div class="line-div">
                                <span></span>
                                <span>
                                    模板详情
                                </span>
                            </div>
                            <div class="dialog-content">
                                <div class="d-item">
                                    <div class="item-left">推送方式：</div>
                                    <div class="item-right">{{ detailObj.sendType }}</div>
                                </div>
                                <div class="d-item" v-if="detailObj.sendType == '标签'">
                                    <div class="item-left">标签：</div>
                                    <div class="item-right">{{ detailObj.labelName }}</div>
                                </div>
                                <div class="d-item">
                                    <div class="item-left">用户列表：</div>
                                    <div class="item-right">
                                        <el-button type="primary" size='mini'
                                            style="background:#1A7BFC;border-color:#1A7BFC"
                                            @click="viewRight = !viewRight">{{ viewRight ? '点击关闭' : '点击查看'
                                            }}</el-button>
                                    </div>
                                </div>
                                <div class="d-item">
                                    <div class="item-left">数据：</div>
                                    <div class="item-right-box">
                                        <div class="box-item" v-for="(item, index) in detailObj.templateBody">
                                            <div class="box-top-text">{{ item.key }}：{{ item.value }}</div>
                                            <div class="box-bottom-text">
                                                <div class="color-box" :style="{ backgroundColor: item.color }"></div>
                                                <div class="color-box-text">（显示具体的颜色或颜色值，不可改动）</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-item">
                                    <div class="item-left">跳转：</div>
                                    <div class="item-right">
                                        <span style="margin-right: 10px;color:#333;font-size:12px">小程序</span>
                                        <el-switch v-model="swichValue" :disabled="true"></el-switch>
                                    </div>
                                </div>
                                <div class="d-item" v-if="swichValue">
                                    <div class="item-left">appID：</div>
                                    <div class="item-right">{{ detailObj.appletAppId }}</div>
                                </div>
                                <div class="d-item" v-if="swichValue">
                                    <div class="item-left">跳转链接：</div>
                                    <div class="item-right">{{ detailObj.pagePath }}</div>
                                </div>
                                <div class="d-item" v-if="detailObj.url">
                                    <div class="item-left">页面路径：</div>
                                    <div class="item-right">{{ detailObj.url }}</div>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="right" v-if="viewRight">
                        <div class="line-div">
                            <span></span>
                            <span>
                                用户列表
                            </span>
                        </div>
                        <div class="dialog-table">
                            <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                                <el-table id="tableInfo" :data="userTableData" style="width: 100%">
                                    <el-table-column prop="nikeName" show-overflow-tooltip label="微信名称" align="center">
                                    </el-table-column>
                                    <el-table-column prop="openId" label="微信ID" show-overflow-tooltip align="center">
                                    </el-table-column>
                                    <el-table-column prop="mobile" show-overflow-tooltip label="手机号" align="center">
                                    </el-table-column>
                                    <el-table-column prop="sendResult" show-overflow-tooltip label="发送状态"
                                        align="center">
                                    </el-table-column>
                                    <el-table-column prop="deliveryResult" show-overflow-tooltip label="接收状态"
                                        align="center">
                                    </el-table-column>
                                </el-table>
                                <div class="dialog-pagination">
                                    <el-pagination background @size-change="handleSizeChange1"
                                        @current-change="handleCurrentChange1"
                                        :current-page.sync="detailUserForm.current" :page-size="detailUserForm.size"
                                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                                    </el-pagination>
                                </div>
                            </el-scrollbar>
                        </div>

                    </div>
                </div>
            </div>
        </el-dialog>
    </el-container>
</template>

<script>
import { wechatTypeNew } from "@/api/customService.js";
import { getSendRecordPage, getDeliveryResult, getTemplateDetail } from '../../api/index.js'
export default {
    data() {
        //这⾥存放数据
        return {
            loading: false,
            templateName: "",
            viewRight: false,
            value1: true,
            setDialog: false,
            total: 0,
            tableTotal: 0,
            times: [],
            userTableData: [],
            selectChange: 1,
            searchForm: {
                appId: '',//筛选公众号对应ID字段
                sendType: "",//推送类型：标签、用户  系统
                templateTitle: "",//模板消息名称
                startTime: "",//开始时间
                endTime: "",//结束时间
                size: 10,
                current: 1,
            },
            detailUserForm: {
                size: 10,
                current: 1,
                sendId: "",//上个列表的主键ID
            },//接收人员接口参数
            wechatList: [],
            tableData: [],
            detailObj: {},//详情数据
            swichValue: false,
            userObj: {},
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        userClose() {
            this.viewRight = false
        },
        //重置数据
        resectData() {
            this.templateName = '';
            this.selectChange = 1;
            this.searchForm.appId = '';
            this.searchForm.sendType = '';
            this.searchForm.templateTitle = '';
            this.searchForm.startTime = '';
            this.searchForm.endTime = '';
            this.searchForm.size = 10;
            this.searchForm.current = 1;
            this.getdata();
        },
        //选择时间触发
        timeChange(e) {
            this.searchForm.startTime = e[0]
            this.searchForm.endTime = e[1]
        },
        //查看详情
        sendDetail(row, index) {
            if (row) {
                this.detailUserForm.sendId = row.id
            }
            getTemplateDetail(this.detailUserForm.sendId).then(res => {
                this.detailObj = res.data
                if (!this.detailObj.appletAppId) {
                    this.swichValue = false
                } else {
                    this.swichValue = true
                }
            })
            getDeliveryResult({ ...this.detailUserForm }).then(res => {
                this.userTableData = res.data.records
                this.total = res.data.total;
            })
            this.setDialog = true
        },
        //获取绑定公众号
        async getWechatType() {
            let res = await wechatTypeNew({ type: 2, ascription: "dsicm" });
            this.wechatList = res.data;
        },
        getdata() {
            if (this.selectChange == 1) {
                this.searchForm.templateTitle = this.templateName;
            }
            this.loading = true
            getSendRecordPage({ ...this.searchForm }).then(res => {
                this.tableData = res.data.records;
                this.tableTotal = res.data.total;
                this.loading = false
            })
        },
        //选择筛选触发事件
        selectChangeFunction(e) {
            this.templateName = "";
            this.searchForm = {
                appId: '',//筛选公众号对应ID字段
                sendType: "",//推送类型：标签、用户  系统
                templateTitle: "",//模板消息名称
                startTime: "",//开始时间
                endTime: "",//结束时间
                size: 10,
                current: 1,
            }
            if (e == 2) {
                this.getWechatType();
            }
        },
        handleSizeChange(e) {
            this.searchForm.size = e
            this.getdata()
        },
        handleCurrentChange(e) {
            this.searchForm.current = e
            this.getdata()
        },
        handleSizeChange1(e) {
            this.detailUserForm.size = e
            this.sendDetail()
        },
        handleCurrentChange1(e) {
            this.detailUserForm.current = e
            this.sendDetail()
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getdata()
    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="less">
/* @import url(); 引⼊公共css类 */
@import './index.less';
</style>